<template lang="pug">
div
  PageTitle: ModifiedDot.ml-2(:show='isModified' color='primary')
  EditQa(ref='editQa' @done='done')
  v-card
    v-alert(type='error' :value='true' icon='warning' v-if='error')
      span(v-if='qas === false') {{ $t('errorWhileLoading') }} {{ error }}
      span(v-else-if='isSaveFailed && error') {{ $t('failedToSave') }} {{ error }}

  v-card(:raised='isModified')
    //- 存檔工具列
    v-toolbar(flat style={ transform: `none` })
      v-spacer
      v-btn(flat icon color='primary' @click='add' :loading='!qas'): v-icon add
    .pb-5(v-if='qas === null')
      v-progress-linear.ma-0(:indeterminate='true')

    //- Qa列表
    v-card-text(v-if='qas && length === 0')
      h6.grey--text 點擊右上角 + 按鈕新增項目

    v-list(two-line v-else-if='qas')
      draggable(v-model='qas' handle='.handle')
        transition-group(name='list')
          v-list-tile(v-for='(i, index) in qas' @click='edit(index)' :key='i._id || i.question')
            v-list-tile-action.handle(@click.stop): v-icon(color='grey') dehaze
            v-list-tile-content
              v-list-tile-title {{ i.question }}
              v-list-tile-sub-title {{ i.answer }}

            v-list-tile-action
              v-tooltip(bottom)
                v-btn.error--text(icon slot='activator' @click.stop='remove(index)'): v-icon close
                span 刪除此項目

  StickyBottomSaveContent(:loading='!qas || isSaving' :show='isModified && qas' :disabled='!qas || isSaving'  @submit='submit' @cancel='discard')
  DebugCodeBlock(:value='qas')
  SnackbarSuccess(ref='successSnackbar')
</template>

<script>
import apis from '@/assets/js/apis'

import { formStatus } from '@/mixins/formStatus'
import draggable from 'vuedraggable'
import Loader from '@/components/Loader.vue'
import ToolbarSaveContent from '@/components/ToolbarSaveContent.vue'
import StickyBottomSaveContent from '@/components/StickyBottomSaveContent.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import PageTitle from '@/components/PageTitle.vue'
import ModifiedDot from '@/components/ModifiedDot.vue'

import EditQa from '@/components/qa/EditQa.vue'

export default {
  name: 'Qa',
  metaInfo () {
    return {
      title: this.$t('Q&A'),
    }
  },
  data () {
    return {
      qas: null,
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    add () {
      this.$refs.editQa.edit()
    },
    edit (index) {
      this.$refs.editQa.edit(this.qas[index], index)
    },
    remove (index) {
      this.qas.splice(index, 1)
    },
    done (data, index) {
      if (index === undefined) {
        this.qas.push(data)
      } else {
        this.$set(this.qas, index, { ...data })
      }
    },
    async fetch () {
      const params = { key: this.userId }

      try {
        this.qas = await apis.qas.get(params, this.token) || []
        this.qas = this.addIdToListItems(this.qas)

        this.clearIsModified()
      } catch (e) {
        this.error = e.response ? e.response.data : e
        this.qas = false
      }
    },
    async submit () {
      const body = { key: this.userId, QA: this.removeIdFromListItems(this.qas) }
      this.isSaving = true
      this.clearError()

      try {
        await apis.qas.put(body, this.token)
        this.$emit('success')
        this.isSaving = false
        this.$refs.successSnackbar.show('成功發佈 Q&A')
        this.discard()
      } catch (e) {
        this.isSaveFailed = true
        this.isSaving = false
        this.error = e.response ? e.response.data : e
      }
    },
    discard () {
      this.qas = null
      this.clearIsModified()
      this.fetch()
    },
  },
  computed: {
    length () {
      return this.qas ? this.qas.length : 0
    },
  },
  watch: {
    qas: {
      handler () {
        this.isModified = true
      },
      deep: true,
    },
  },
  components: {
    draggable,
    Loader,
    EditQa,
    ToolbarSaveContent,
    StickyBottomSaveContent,
    SnackbarSuccess,
    PageTitle,
    ModifiedDot,
  },
  mixins: [formStatus],
}
</script>
